import { z } from 'zod/v4';

export interface MachineTokenResponse extends z.infer<typeof MachineTokenResponseRuntype> {}
export const MachineTokenResponseRuntype = z.object({
    id: z.string(),
    token: z.string(),
    name: z.string(),
    expiration_date: z.string().nullable(),
    roles: z.array(z.string()),
    tenant: z.string(),
});

export interface MachineTokenCreateRequest extends z.infer<typeof MachineTokenCreateRequestRuntype> {}
export const MachineTokenCreateRequestRuntype = z.object({
    name: z.string(),
    expiration_date: z.string().nullable(),
    roles: z.array(z.string()),
});

export interface MachineTokenUpdateRequest extends z.infer<typeof MachineTokenUpdateRequestRuntype> {}
export const MachineTokenUpdateRequestRuntype = z.object({
    name: z.string(),
    expiration_date: z.string().nullable(),
    roles: z.array(z.string()),
});

export interface AvailableRole extends z.infer<typeof AvailableRoleRuntype> {}
export const AvailableRoleRuntype = z.object({
    value: z.string(),
    description: z.string().nullable(),
});
